<template>
  <div>
    <RadioBox
      label="With Images"
      value="full"
      name="option"
      :isChecked="true"
      class="mb-15"
      v-model:change="downloadOption"
    />
    <RadioBox
      label="Text Only"
      value="clean"
      name="option"
      class="mb-20"
      v-model:change="downloadOption"
    />
    <button class="button button-primary" @click="handleDownload">
      Download PDF</button
    >
  </div>
</template>
<script>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import RadioBox from '~/components/ui/radio-box/RadioBox.vue'
import tripApi from '~/composables/api/tripApi'
import { publicDomain } from '~/helper'
import { debounceHeapTracking } from '~/mixins/heap'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
export default {
  name: 'ModalDownload',
  components: {
    RadioBox,
  },
  props: {
    modalActive: {
      type: Boolean,
      default: false,
      required: true,
    },
    id: {
      type: Number,
    },
    currency: {
      type: String,
      default: 'AUD',
      required: true,
    },
    pageType: {
      type: String,
      default: 'gallery',
      validator: (value) =>
        ['gallery', 'bookable', 'preview'].includes(value.toLowerCase()),
    },
  },
  emits: ['update:modalActive'],
  setup(props, { emit }) {
    const domain = publicDomain()
    const route = useRoute()
    const downloadOption = ref('full')

    const modalDownloadActive = computed({
      get: () => props.modalActive,
      set: (value) => emit('update:modalActive', value),
    })

    /*const handleDownload = async () => {
      //loading
      store.commit('generalStore/setLoading', true)
      let params = {
        id: props.id,
        type: downloadOption.value,
        currency: props.currency,
        version: props.pageType,
      }
      if (domain === 'agentpreview') {
        params['version'] = 'share'
        params['idShare'] = route.params.trip
      }
      const {
        data: { data: resp },
      } = await tripApi.downloadBrochure(params)
      store.commit('generalStore/setLoading', false)
      // Download in new tab
      let popUp = window.open(resp, '_blank')
      if (popUp === null || typeof(popUp) === undefined) {
        alert('Please disable your pop-up blocker and try again.');
      }
      else {
        popUp.focus();
      }
    }*/
    const handleDownload = async () => {
      let params = {
        id: props.id,
        type: downloadOption.value,
        currency: props.currency,
        version: props.pageType,
      }

      if (domain === 'agentpreview') {
        params['version'] = 'share'
        params['idShare'] = route.params.trip
      }

      if (domain === 'agent') {
        params['version'] = 'share'
        const resp =
          route.name === 'enquiries-listing'
            ? await tripApi.getTrip(props.id)
            : await tripApi.getTrip(route.params.trip)
        // const tripData = (resp && resp.data) ? resp.data.data : (resp.id ? resp : null)
        const tripData = resp.data.value?.data
        params['idShare'] = tripData ? tripData.shared_id : null
      }

      // Download in new tab
      let popUp = window.open(tripApi.getDownloadPdfLink(params), '_blank')
      if (popUp === null || typeof(popUp) === undefined) {
        alert('Please disable your pop-up blocker and try again.');
      }
      else {
        popUp.focus();
        debounceHeapTracking("Download Trip Plan", {
          has_image_included: downloadOption.value === 'full',
          is_sent_to_email: false
        })
        debounceAmplitudeScriptTracking("Download Trip Plan", {
          has_image_included: downloadOption.value === 'full',
          is_sent_to_email: false
        })
      }
    }

    return {
      modalDownloadActive,
      downloadOption,
      handleDownload,
    }
  },
}
</script>
